import { render, staticRenderFns } from "./BTN002n_back.vue?vue&type=template&id=f00ae2d6&scoped=true&"
import script from "./BTN002n_back.vue?vue&type=script&lang=js&"
export * from "./BTN002n_back.vue?vue&type=script&lang=js&"
import style0 from "./BTN002n_back.vue?vue&type=style&index=0&id=f00ae2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00ae2d6",
  null
  
)

export default component.exports